'use client';

import type { Dispatch, MouseEventHandler, SetStateAction } from 'react';
import { createContext } from 'react';

import type { PopperOwnProps } from '@mui/base/Popper';
import type { VirtualElement } from '@popperjs/core';

export type PopperContext = /* Omit<PopperProps, 'open'> & */ {
  id: string | undefined;
  isOpen: boolean;
  anchorEl: PopperOwnProps['anchorEl'];
  // children: PopperOwnProps['children'];
  container: PopperOwnProps['container'];
  direction: PopperOwnProps['direction'];
  disablePortal: PopperOwnProps['disablePortal'];
  keepMounted: PopperOwnProps['keepMounted'];
  modifiers: PopperOwnProps['modifiers'];
  placement: PopperOwnProps['placement'];
  popperOptions: PopperOwnProps['popperOptions'];
  popperRef: PopperOwnProps['popperRef'];
  slotProps: PopperOwnProps['slotProps'];
  slots: PopperOwnProps['slots'];
  transition: PopperOwnProps['transition'];
  setAnchorEl: Dispatch<
    SetStateAction<
      | VirtualElement
      | HTMLElement
      | (() => HTMLElement)
      | (() => VirtualElement)
      | null
      | undefined
    >
  >;
  handleOpen: MouseEventHandler<HTMLElement>;
  handleClose: (event: MouseEvent | TouchEvent) => void; // MouseEventHandler<HTMLElement>;
  handleToggle: MouseEventHandler<HTMLElement>;
};

const defaultValue: PopperContext = {
  isOpen: false,
  anchorEl: void 0,
  setAnchorEl: (): void => void 0,
  handleToggle: (): void => void 0,
  handleOpen: (): void => void 0,
  handleClose: (): void => void 0,
};

export const Context = createContext<PopperContext>( defaultValue );
